import InfoIcon from '@assets/icons/info.svg?react'
import { useState } from 'react'
import { Popover } from 'react-tiny-popover'

import s from './TooltipInfo.module.scss'
import type { TooltipInfoProps } from './TooltipInfo.props'

export function TooltipInfo({ text, position = 'top' }: TooltipInfoProps) {
  const [visible, setVisible] = useState(false)

  const showTooltip = () => setVisible(true)
  const hideTooltip = () => setVisible(false)

  return (
    <Popover
      isOpen={visible}
      positions={position}
      onClickOutside={hideTooltip}
      transform={{ top: -6 }}
      transformMode="relative"
      align="start"
      containerStyle={{ zIndex: '20' }}
      content={<div className={s.tooltip}>{text}</div>}
    >
      <div
        className={s.wrapper}
        onClick={showTooltip}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        <InfoIcon />
      </div>
    </Popover>
  )
}
